import { useState, useEffect } from 'react';
import { Avatar, Button, Typography, Box, Tooltip } from '@mui/material';
import { styled } from '@mui/system';
import useMediaQuery from '@mui/material/useMediaQuery';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew'; // Power off icon
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import CareerSettings from "../Images/careersettingswhite.png";
import Loader from '../common/Loader';
const Container = styled('div')({
  width: '100vw',
  height: '100%',
  position: 'relative',
  backgroundColor: 'white',
});

const TopBanner = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'black',
  padding: '24px 32px',
  position: 'relative',
  minHeight: '200px',
});

const BackgroundImage = styled('img')({
  maxWidth: '250px',
  height: 'auto',
  marginBottom: '16px',
});

const ProfileAvatar = styled(Avatar)({
  width: '32px',
  height: '32px',
  backgroundColor: '#DBEAF9',
  border: '2px solid white',
  cursor: 'pointer',
});

const WelcomeSection = styled('div')(({ isMobile }) => ({
  textAlign: 'left',
  position: 'absolute',
  top: '92px',
  padding: isMobile ? '20px' : '0px',
  left: isMobile ? '0px' : '325px',
  zIndex: 2,
}));

const WelcomeText = styled(Typography)(({ isMobile }) => ({
  color: 'white',
  fontSize: isMobile ? '16px' : '24px',
  fontWeight: 600,
  lineHeight: isMobile ? '20px' : '32px',
  fontFamily: 'Volte',
  wordWrap: 'break-word',
}));

const SectionContainer = styled('div')(({ isMobile }) => ({
  display: isMobile ? 'block' : 'flex',
  width: isMobile ? '100%' : '720px',
  position: 'absolute',
  top: '361px',
  left: isMobile ? '0' : '171px',
  gap: isMobile ? '20px' : '100px',
  padding: isMobile ? '16px' : '0',
  marginBottom: isMobile ? '25px' : '0',
}));

const InnerContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: '16px',
  marginBottom: '16px',
  maxWidth: '320px',
});

const IconWrapper = styled('div')({
  padding: '10px',
  backgroundColor: 'black',
  borderRadius: '32px',
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const ContentWrapper = styled('div')({
  display: 'inline-flex',
  flexDirection: 'column',
  gap: '13px',
});

const Title = styled(Typography)({
  fontSize: '24px',
  fontWeight: 600,
  fontFamily: 'Volte',
  color: '#202020',
});

const Description = styled(Typography)({
  fontSize: '14px',
  fontWeight: 600,
  fontFamily: 'Volte',
  color: '#202020',
});

const StyledButton = styled(Button)({
  backgroundColor: 'black',
  color: 'white',
  padding: '8px 20px',
  borderRadius: '32px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#f0f0f0',
    color: 'black',
  },
});

const CareerSettingsPortal = ({ accountInfo, logout }) => {
  const isMobile = useMediaQuery('(max-width:900px)');
  const [tools, setTools] = useState([]);
  const [loading, setLoading] = useState(false); // Loading state

  // useEffect(() => {
  //   const checkAccess = async () => {
  //     try {
  //       const token = accountInfo?.jwtIdToken;
  //       const response = await fetch(
  //         'https://api-promotion-test.cfapps.eu20.hana.ondemand.com/api/v1/check-access',
  //         {
  //           method: 'POST',
  //           headers: {
  //             'accessToken': token,
  //             'Content-Type': 'application/json'
  //           }
  //         }
  //       );
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }
  //       const result = await response.json();
  //       setTools(result?.data);
  //     } catch (error) {
  //       console.error('Error checking access:', error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   checkAccess();
  // }, [accountInfo]);

  const handleGoHome = () => {
    window.name = JSON.stringify(accountInfo);
    window.location.href = process.env.REACT_APP_OFFBOARDINGTOOL_REDIRECT_URL;
  };

  const handleOpenPromotionTool = () => {
    window.name = JSON.stringify(accountInfo);
    window.location.href = process.env.REACT_APP_PROMOTION_NOMINATION_TOOL_REDIRECT_URL;
  };

  return (
    <Container>
      <TopBanner isMobile={isMobile}>
        <BackgroundImage src={CareerSettings} alt="Background" isMobile={isMobile} />
        <Box
          style={{
            position: 'absolute',
            top: '24px',
            right: '24px',
            zIndex: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '8px',
          }}
        >
          <Tooltip
            title={accountInfo.account.name || ''}
            arrow
            placement="bottom"
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: '#202020',
                  fontWeight: 500,
                  color: '#FFFFFF',
                  fontSize: '1rem',
                  padding: 1,
                },
              },
            }}
          >
            <ProfileAvatar>
              <Typography color="#1077D6" fontSize={14} fontWeight="600">
                {accountInfo.account.name
                  .split(' ')
                  .map((namePart) => namePart[0])
                  .join('')}
              </Typography>
            </ProfileAvatar>
          </Tooltip>
          <Button
            onClick={logout}
            style={{
              backgroundColor: 'white',
              borderRadius: '50%',
              minWidth: '0',
              padding: '4px',
            }}
          >
            <PowerSettingsNewIcon fontSize="small" style={{ color: 'black' }} />
          </Button>
        </Box>

        <WelcomeSection isMobile={isMobile}>
          <WelcomeText isMobile={isMobile}>
            Hi {accountInfo.account.name},
            <br />
            Welcome to the Career Settings Plus Portal.
          </WelcomeText>
        </WelcomeSection>
      </TopBanner>

      <SectionContainer isMobile={isMobile}>
        {loading ? (
         <Loader fullscreen={true}/>
        ) : (
          <>
            {/* {tools?.some(tool => tool.toolType === 'OFB') && ( */}
              <InnerContainer>
                <ContentWrapper>
                  <Title>
                    <IconWrapper>
                      <PowerSettingsNewIcon sx={{ color: 'white', width: '16px', height: '16px' }} />
                    </IconWrapper>
                    <span style={{ paddingLeft: '10px' }}>Offboarding</span>
                  </Title>
                  <Description>
                    For all your Offboarding related actions, kindly click below.
                  </Description>
                  <StyledButton onClick={handleGoHome}>Get Started</StyledButton>
                </ContentWrapper>
              </InnerContainer>
            {/* )} */}
            {/* {tools?.some(tool => tool.toolType === 'PNPSAP') && ( */}
              <InnerContainer>
                <ContentWrapper>
                  <Title>
                    <IconWrapper>
                      <WorkspacePremiumIcon sx={{ color: 'white', width: '16px', height: '16px' }} />
                    </IconWrapper>
                    <span style={{ paddingLeft: '10px' }}>Promotion Nominations</span>
                  </Title>
                 <Description>
                  For all your Promotion Nominations related actions, kindly click below.
                </Description>
                <StyledButton onClick={handleOpenPromotionTool}>Get Started</StyledButton>
                </ContentWrapper>
              </InnerContainer>
            {/* )} */}
          </>
        )}
      </SectionContainer>
    </Container>
  );
};

export default CareerSettingsPortal;
